<template>
    <div class="width-full">
        <v-container fluid grid-list-xl class="container-symptoms-questions general-container">
            <v-layout row wrap class="navigation-header">
                <v-flex xs12>
                    <header-bar></header-bar>
                </v-flex>
            </v-layout>


            <v-layout row wrap class="page-content with-alerts pf-standard-mobile pf-mobile-related-symptoms">
                <v-flex lg4 offset-lg4 md8 offset-md2 sm8 offset-sm2 xs12 class="no-padding">
                    <p class="page-title-pf no-margin-bottom hidden-xs-only">{{text('api.pdf.pageTitle.sharedQuestions')}}</p>
                    <standard-stepper  :steps="step"></standard-stepper>
                    <description class="margin-top-xl"></description>

                </v-flex>

                <v-flex lg4 offset-lg4 md6 offset-md3 sm8 offset-sm2 xs12 class="no-padding-right no-padding-left">
                    <div class="main-symptom-section start-assessment-section-pf related-symptoms-page-pf shared-questions-page-pf">
                    <v-card class="pf-related-symptoms shared-questions-pf">
                        <v-card-text class="general-content pf-question">
                                    <question-list-block
                                        :questions="sharedQuestionList"
                                        :title="text('db.product.PROD_TITLE_SHA')"
                                        :questionsCountAnswered="getSharedQuestionsData.countAnswered"
                                        :questionsCountTotal="getSharedQuestionsData.countTotal"
                                        titleClasses="symptom-name font-weight-bold font-size-default text-transform-none"
                                        @onProvideAnswer="handleProvideAnswer">
                                    </question-list-block>

                        </v-card-text>

                        <v-card-actions class="pf-actions hidden-xs-only">
                            <v-btn flat color="grey darken-1" @click="goToPreviousPage" class="footer-btn">
                                <v-icon>keyboard_arrow_left</v-icon>
                                {{ text('api.button.back') }}
                            </v-btn>
                            <v-btn flat color="primary" @click="goToNextPage"  class="footer-btn footer-btn-next">
                                {{ text('api.button.evaluate')}}
                                <v-icon>keyboard_arrow_right</v-icon>
                            </v-btn>
                        </v-card-actions>
                    </v-card>
                    </div>
                </v-flex>

            </v-layout>

            <v-layout>
                <v-flex>
                    <div class="footer pf-standard-mobile hidden-sm-and-up">
                            <v-btn flat color="grey darken-1" @click="goToPreviousPage" class="footer-btn back-pf">
                                <v-icon>keyboard_arrow_left</v-icon>
                                {{ text('api.button.back') }}
                            </v-btn>

                            <mobile-stepper  :steps="step"></mobile-stepper>

                            <v-btn flat color="primary" @click="goToNextPage" class="footer-btn footer-btn-next next-pf">
                                {{ text('api.button.next') }}
                                <v-icon>keyboard_arrow_right</v-icon>
                            </v-btn>
                    </div>
                </v-flex>
            </v-layout>
        </v-container>


    </div>
</template>

<script>
    import HeaderBar from "../../shared/HeaderBar";
    import {mapGetters} from 'vuex';
    import QuestionListBlock from "../../../../common/components/shared/QuestionListBlockPf";
    import Description from '../../shared/Description';
    import StandardStepper from '../../shared/StandardStepper';
    import MobileStepper from '../../shared/MobileStepper';

    export default {
        name: "SharedQuestionsPage",
        components: {
            HeaderBar,
            QuestionListBlock,
            Description,
            StandardStepper,
            MobileStepper
        },
        data() {
            return {
                step: 6,
            }
        },
        computed: {
            ...mapGetters({
                getSharedQuestionsData: 'PfSharedQuestionsStore/getSharedQuestionsData',
                sharedQuestionList: 'PfSharedQuestionsStore/getSharedQuestionList',

            })
        },
        methods: {

            goToPreviousPage() {
                this.$router.push('/pathfinder/symptom-questions');
            },

            goToNextPage() {
                this.$router.push('/pathfinder/scoring');
            },

            handleProvideAnswer(data) {
                this.$store.dispatch('PfSharedQuestionsStore/submitSymptomQuestionAnswer', data);
            }

        },
        created() {
            let requestloadSharedQuestionsData = this.$store.dispatch("PfSharedQuestionsStore/loadSharedQuestionsData");
            requestloadSharedQuestionsData.catch((error) => {
                // If no Main Symptom has been choosed yet (server sends {returnCode:205}), redirect to Assessment Start page.
                if (typeof error.serverResponse !== "undefined"
                    && typeof error.serverResponse.data !== "undefined"
                    && typeof error.serverResponse.data.returnCode !== "undefined"
                    && error.serverResponse.data.returnCode === 0) {
                    this.$router.push('/general-questions');
                }
            });
        }
    }
</script>

<style scoped lang="scss">

    .pf-related-symptoms {

        .general-content {
            padding: 10px 20px 20px !important;

            .card {
                box-shadow: none !important;
                margin-top: 35px;

                .card__text:first-child {
                    border-top: none !important;
                }

                .card__text {

                    .question-item{
                        margin: 7px 0;
                    }

                }
            }
        }
    }

    .scrolling-content {
        overflow: hidden !important;
    }

    .scrolling-content.path {
        top: 110px !important;
    }

    @media only screen and (max-width: 600px) {
        .pf-standard-mobile.pf-mobile-related-symptoms {
            margin-top: 0 !important;
            background-color: $color-gray-lightest;
        }

        .footer-btn-next.next-pf {
            position: absolute;
            right: 0;
            bottom: 4px;
        }

        .footer-btn.back-pf {
            position: absolute;
            top: 4px;
        }

        .pf-standard-mobile {
            .footer-btn-next {
                background-color: $color-block-background;
                color: $color-block-background;
            }

            &.btn--disabled {
                color: rgba(0,0,0,.26) !important;
            }
        }

        .main-symptom-section.start-assessment-section-pf.related-symptoms-page-pf{

            height: auto !important;
            margin-bottom: 0 !important;
            padding: 0;

            .pf-related-symptoms {

                .card__text.general-content {
                    height: calc(100vh - 247px) !important;
                    overflow: auto;
                }

            }

        }

        .pf-related-symptoms {

            .general-content {
                height: auto !important;
            }
        }
    }

    @media only screen and (min-width: 601px) {
        .pf-standard-mobile.pf-mobile-related-symptoms {
            margin-top: 30px !important;
        }

        .pf-related-symptoms.shared-questions-pf {

            height: 100% !important;

            .general-content {
                padding: 0 !important;
                height: calc(100% - 60px) !important;
                overflow: auto !important;
            }

            .pf-actions {
                height: 60px;
                position: absolute;
                bottom: 0;
            }
        }

        .shared-questions-page-pf {
            padding: 0 !important;

            .questions {
                bottom: 0 !important;
                height: 100% !important;
                padding: 20px 28px 0 20px !important;
            }
        }

        .pf-standard-mobile {
            .footer-btn-next {
                background-color: $color-block-background;
                color: $color-brand-primary;
            }
        }

    }
</style>




// WEBPACK FOOTER //
// src/pathfinder/components/standard-forms/shared-questions/SharedQuestionsPage.vue